import { createFileRoute } from '@tanstack/react-router';
import { PipePage } from '@/pages/PipePage';

export const Route = createFileRoute('/_authed/pipe')({
  component: PipePage,
});
